<div *ngIf="fieldName">
  <div ngClass="{{!!displayLabel ? 'form-group' : ''}} {{ displayFieldCss() }} {{ cls }}">
    <label [ngClass]="isRequired() ? 'required ' + clsLabel : clsLabel"
      [for]="id" *ngIf="!!displayLabel">
      {{displayLabel}}<span class="required-alert" *ngIf="!!isRequired()">*</span>
    </label>

    <input #input type="date" class="form-control" *ngIf="layout == 'default'"
      [id]="id" (blur)="onBlur($event)" [readOnly]="readOnly"
      [placeholder]="placeholder ? placeholder : displayLabel || ''"
      [ngModel]="value" (ngModelChange)="valueChange($event)"
      [disabled]="disabled"
      ngClass="{{touched ? 'ng-touched ' + clsInput  : clsInput}} {{inputClass}}"
    >

    <input #input type="text" class="form-control" *ngIf="layout == 'ngx'"
      #dp="bsDatepicker" bsDatepicker
      [id]="id" (blur)="onBlur($event)" [readOnly]="readOnly"
      [placeholder]="placeholder ? placeholder : displayLabel || ''"
      [ngModel]="value" (ngModelChange)="valueChange($event)"
      [minDate]="minDate" [maxDate]="maxDate" [datesDisabled]="disabledDates"
      [disabled]="disabled"
      [bsConfig]="getBsConfig()"
      ngClass="{{touched ? 'ng-touched ' + clsInput  : clsInput}} {{inputClass}}"
    >

    <app-datepicker #input *ngIf="layout == 'primeface'"
      [id]="id" [format]="format" [maxNow]="maxNow"
      (onSelect)="valueChange($event)" (blur)="onBlur($event)"
      style="text-align-last: center" [readOnly]="readOnly"
      [disabled]="disabled" [timeOnly]="timeOnly"
      ngClass="{{touched ? 'ng-touched ' + clsInput  : clsInput}} {{inputClass}}">
    </app-datepicker>

    <app-field-error-display *ngIf="errorMsg"
      [displayError]="isFieldInvalid()"
      [errors]="getFieldError()"
      [errorMsg]="errorMsg">
    </app-field-error-display>
  </div>
</div>
